// Public social links — keep in one place so tweaks ship everywhere.
export const TELEGRAM_INVITE_LINK = "https://t.me/breakoutscanner_NSE";
export const TELEGRAM_CHANNEL_NAME = "Breakout Scanner_NSE";
